import React, { useState, useEffect } from "react";
import { Alert, Button, Col, Descriptions, Divider, Form, InputNumber, Layout, Modal, Row, Table, Tag, Typography, Skeleton, Space } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined, BankOutlined } from '@ant-design/icons';
import "./style.scss";
import { useNavigate, useParams } from "react-router-dom";
import { cloneDeep } from "lodash";
import moment from "moment-timezone";
import { inject, observer } from "mobx-react";

const { Content } = Layout;
const { Text } = Typography;

const ViewEvent = ({ userStore, eventStore, voterStore }) => {

  const { Title } = Typography;
  const navigate = useNavigate()
  
  const [showData, setShowData] = useState(false);
  const [user, setUser] = useState();

  // const teamLeaderID = eventStore.event && eventStore.event.TeamLeaderID;
  const teamLeaderID = '';
  const statusPending = 'PENDING';
  const statusReceived = 'RECEIVED';

  let { id } = useParams();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowData(true);
    }, 500);

    return () => clearTimeout(timeout); // Clear the timeout if the component is unmounted

  }, []);

  useEffect(() => {
    const login_user = JSON.parse(localStorage.getItem(`dXNlclN0b3Jl`)) || [];
    setUser(login_user);
    if(id){
      eventStore.fetchEventByID(id);
    }
  }, [id]);

  useEffect(() => {

    voterStore.pageCash = 1;
    voterStore.hasMoreCash = false;
    voterStore.perPageCash = 10;

    voterStore.pageItem = 1;
    voterStore.hasMoreItem = false;
    voterStore.perPageItem = 20;

    voterStore.fetchVoterAmountEventCashByID(id, teamLeaderID, statusPending);
    voterStore.fetchVoterAmountEventItemByID(id, teamLeaderID, statusReceived);
  }, []);

  const formatNumber = (formatnumber) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(formatnumber);
  };

  // const columnsCash = [
  //   {
  //     title: 'Name',
  //     key: 'VotersName+VotersAmountID',
  //     dataIndex: 'VotersName',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (VotersName) => (
  //       <Text default italic>{VotersName}</Text>
  //     )
  //   },
  //   {
  //     title: 'Amount',
  //     key: 'Amount+VotersAmountID',
  //     dataIndex: 'Amount',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (Amount) => (
  //       <Text default strong>₱ {formatNumber(Amount)}</Text>
  //     )
  //   },
  //   {
  //     title: 'Remarks',
  //     key: 'Remarks+VotersAmountID',
  //     dataIndex: 'Remarks',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (Remarks) => (
  //       <Text default italic>{Remarks ? Remarks : "-"}</Text>
  //     )
  //   },
  //   {
  //     title: 'Transaction Date',
  //     key: 'CreatedAt+VotersAmountID',
  //     dataIndex: 'CreatedAt',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (CreatedAt) => (
  //       <Text default>{moment.utc(CreatedAt).format("MMM DD, YYYY h:mm A")}</Text>
  //     )
  //   },
  //   {
  //     title: 'Transact By',
  //     key: 'LoadedBy+VotersAmountID',
  //     dataIndex: 'LoadedBy',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (LoadedBy) => (
  //       <Tag><Text type="primary" strong>{LoadedBy}</Text></Tag>
  //     )
  //   },
  // ];

  // const columnsItem = [

  //   {
  //     title: 'Name',
  //     key: 'VotersName+VotersAmountID',
  //     dataIndex: 'VotersName',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (VotersName) => (
  //       <Text default italic>{VotersName}</Text>
  //     )
  //   },
  //   {
  //     title: 'Item',
  //     key: 'ItemName+VotersAmountID',
  //     dataIndex: 'ItemName',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (ItemName) => (
  //       <Text default strong>{ItemName}</Text>
  //     )
  //   },
  //   {
  //     title: 'Quantity',
  //     key: 'Quantity+VotersAmountID',
  //     dataIndex: 'Quantity',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (Quantity) => (
  //       <Text default strong>{Quantity}</Text>
  //     )
  //   },
  //   {
  //     title: 'PPU',
  //     key: 'PricePerUnit+VotersAmountID',
  //     dataIndex: 'PricePerUnit',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (PricePerUnit) => (
  //       <Text default strong>₱ {formatNumber(PricePerUnit)}</Text>
  //     )
  //   },
  //   {
  //     title: 'Total Amount',
  //     key: 'Amount+VotersAmountID',
  //     dataIndex: 'Amount',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (Amount) => (
  //       <Text default strong>₱ {formatNumber(Amount)}</Text>
  //     )
  //   },
  //   {
  //     title: 'Transaction Date',
  //     key: 'CreatedAt+VotersAmountID',
  //     dataIndex: 'CreatedAt',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (CreatedAt) => (
  //       <Text default>{moment.utc(CreatedAt).format("MMM DD, YYYY h:mm A")}</Text>
  //     )
  //   },
  //   {
  //     title: 'Transact By',
  //     key: 'LoadedBy+VotersAmountID',
  //     dataIndex: 'LoadedBy',
  //     responsive: ['lg', 'xl', 'md'],
  //     render: (LoadedBy) => (
  //       <Tag><Text type="primary" strong>{LoadedBy}</Text></Tag>
  //     )
  //   },
  // ];

  const columnsRegistered = [
      {
        title: 'ID',
        key: 'DisplayedID+EventRegistrationID',
        dataIndex: 'DisplayedID',
        render: (DisplayedID) => (
          <Text default strong>{DisplayedID}</Text>
        )
      },
      {
        title: 'Name',
        key: 'VoterName+EventRegistrationID',
        dataIndex: 'VoterName',
        render: (VoterName) => (
          <Text default>{VoterName}</Text>
        )
      },
  
      {
        title: 'Status',
        dataIndex: 'Status',
        responsive: ['lg', 'xl', 'md'],
        render: (Status) => (
          <Text default strong><Tag color={Status === 'RECEIVED' ? 'green' : 'blue'}>{Status}</Tag></Text>
        )
      },
    ];
  
    const columnsReceived = [
      {
        title: 'ID',
        key: 'DisplayedID+EventRegistrationID',
        dataIndex: 'DisplayedID',
        render: (DisplayedID) => (
          <Text default strong>{DisplayedID}</Text>
        )
      },
      {
        title: 'Name',
        key: 'VoterName+EventRegistrationID',
        dataIndex: 'VoterName',
        render: (VoterName) => (
          <Text default>{VoterName}</Text>
        )
      },
  
      {
        title: 'Status',
        key: 'Status+EventRegistrationID',
        dataIndex: 'Status',
        render: (Status) => (
          <Text default strong><Tag color={Status === 'RECEIVED' ? 'green' : 'blue'}>{Status}</Tag></Text>
        )
      },
    ];

  const handlePrevPageCash = () => {
    voterStore.pageCash = voterStore.pageCash - 1;
    // voterStore.fetchVoterAmountEventCashByID(id);

    voterStore.fetchVoterAmountEventCashByID(id, teamLeaderID, statusPending);
  };

  const handleNextPageCash = () => {
    voterStore.pageCash = voterStore.pageCash + 1;
    // voterStore.fetchVoterAmountEventCashByID(id);

    voterStore.fetchVoterAmountEventCashByID(id, teamLeaderID, statusPending);
  };

  const handlePrevPageItem = () => {
    voterStore.pageItem = voterStore.pageItem - 1;
    // voterStore.fetchVoterAmountEventItemByID(id);

    voterStore.fetchVoterAmountEventItemByID(id, teamLeaderID, statusReceived);
  };

  const handleNextPageItem = () => {
    voterStore.pageItem = voterStore.pageItem + 1;
    // voterStore.fetchVoterAmountEventItemByID(id);

    voterStore.fetchVoterAmountEventItemByID(id, teamLeaderID, statusReceived);
  };

  return (
    <div className="view-voter">
      <Content>
        <div className="view-voter-content">
          <Title level={4}>Event Details</Title>
          <Divider />
          {
            showData ? (
            <>
              <div className="information">
                <Descriptions column={2} bordered>
                  <Descriptions.Item label="Event Name" span={1}>
                    <Text type="primary">{ eventStore.event && eventStore.event.EventName }</Text>
                  </Descriptions.Item>
                  <Descriptions.Item label="Event Date" span={1}>
                    <Text type="primary">{ moment(eventStore.event && eventStore.event.Date).format("MMM DD, YYYY") }</Text>
                  </Descriptions.Item>
                  <Descriptions.Item label="Location" span={1}>
                    <Text type="primary">{ eventStore.event && eventStore.event.Location }</Text>
                  </Descriptions.Item>
                </Descriptions>
                <Divider/>
                <Descriptions column={2} bordered>
                  <Descriptions.Item label="Total Spent Budget" span={1}>
                    <Text type="primary">₱ { formatNumber( eventStore.event && eventStore.event.TotalAmount ) }</Text>
                  </Descriptions.Item>
                </Descriptions>
                <Divider/>
                <>
                  <Row justify={"space-between"} align={"middle"}>
                    <Col>
                      <Title level={5}>Voters Pending List</Title>
                    </Col>
                    <Col>
                      {
                        eventStore.event && eventStore.event.TeamLeaderID == user.userID ? (
                          <Space>
                            <Button type="primary" onClick={() => navigate('add')}><BankOutlined/>Distribute Amount</Button>
                            <Button type="primary" onClick={() => navigate('additem')}><BankOutlined/>Distribute Item</Button>
                          </Space>
                        ) : null
                      }
                    </Col>
                  </Row>
                  
                  <Table pagination={false} columns={columnsRegistered} dataSource={cloneDeep(voterStore.votersCashAmounts)} bordered
                    expandable={{
                      expandedRowRender: (record) => (
                        <>
                        <Title level={5}>Item Details</Title>
                        <Row gutter={20}>
                          <Col>
                            <Text type="primary">Item : </Text><Text type="primary" strong>{record.ItemName ? record.ItemName : "N/A"}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Quantity : </Text><Text type="primary" strong>{record.ItemQuantity}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Price Per Unit : </Text><Text type="primary" strong>₱{formatNumber(record.ItemPricePerUnit)}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Item Amount : </Text><Text type="primary" strong>₱{formatNumber(record.ItemTotalAmount)}</Text>
                          </Col>
                        </Row>
                        <Title level={5}>Cash Details</Title>
                        <Row gutter={20}>
                          <Col>
                            <Text type="primary">Item : </Text><Text type="primary" strong>Cash</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Cash Amount : </Text><Text type="primary" strong>₱{formatNumber(record.Cash)}</Text>
                          </Col>
                        </Row>
                        </>
                      ),
                      // rowExpandable: (record) => record.name !== 'Not Expandable',
                    }}
                  />
                  <ul className="pagination">
                    <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPageCash} disabled={voterStore.pageCash == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                    <li className="pagination-item"><a>{voterStore.pageCash}</a></li>
                    <li className="pagination-next "><Button type="dashed" onClick={handleNextPageCash} disabled={voterStore.hasMoreCash ? false : true}>Next<CaretRightOutlined /></Button></li>
                  </ul>
                  <Divider/>
                  <Row justify={"space-between"} align={"middle"}>
                    <Col>
                      <Title level={5}>Voters Received List</Title>
                    </Col>
                  </Row>
                  <Table pagination={false} columns={columnsReceived} dataSource={cloneDeep(voterStore.votersItemAmounts)} bordered
                    expandable={{
                      expandedRowRender: (record) => (
                        <>
                        <Title level={5}>Item Details</Title>
                        <Row gutter={20}>
                          <Col>
                            <Text type="primary">Item : </Text><Text type="primary" strong>{record.ItemName ? record.ItemName : "N/A"}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Quantity : </Text><Text type="primary" strong>{record.ItemQuantity}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Price Per Unit : </Text><Text type="primary" strong>₱{formatNumber(record.ItemPricePerUnit)}</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Item Amount : </Text><Text type="primary" strong>₱{formatNumber(record.ItemTotalAmount)}</Text>
                          </Col>
                        </Row>
                        <Title level={5}>Cash Details</Title>
                        <Row gutter={20}>
                          <Col>
                            <Text type="primary">Item : </Text><Text type="primary" strong>Cash</Text>
                          </Col>
                          <Col>
                            <Text type="primary">Cash Amount : </Text><Text type="primary" strong>₱{formatNumber(record.Cash)}</Text>
                          </Col>
                        </Row>
                        </>
                      ),
                      // rowExpandable: (record) => record.name !== 'Not Expandable',
                    }}
                  />
                  <ul className="pagination">
                    <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPageItem} disabled={voterStore.pageItem == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                    <li className="pagination-item"><a>{voterStore.pageItem}</a></li>
                    <li className="pagination-next "><Button type="dashed" onClick={handleNextPageItem} disabled={voterStore.hasMoreItem ? false : true}>Next<CaretRightOutlined /></Button></li>
                  </ul>
                </>
                <Divider/>
              </div>
            </>
            ) : <Skeleton active/>
          }
          <Divider/>
          <Row justify={'end'} gutter={10}>
            <Col>
              <Button onClick={() => navigate(-1)}>Back</Button>
            </Col>
          </Row>
        </div>
      </Content>
    </div>

  );
};

export default inject('userStore', 'eventStore', 'voterStore')(observer(ViewEvent));

